import { render, staticRenderFns } from "./EduCourseDetails.vue?vue&type=template&id=3d2311df"
import script from "./EduCourseDetails.vue?vue&type=script&lang=js"
export * from "./EduCourseDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports